import {
  AuthApiFactory,
  Configuration,
  SubscriptionsApiFactory,
  PaymentsApiFactory,
  ProfileApiFactory,
  UsersApiFactory,
} from '@growdash/identity/generated';
import { InitializeService } from '../types/initialize-service';

export const apiFactories = {
  authAPI: AuthApiFactory,
  usersAPI: UsersApiFactory,
  selfserveAPI: SubscriptionsApiFactory,
  paymentsAPI: PaymentsApiFactory,
  profileAPI: ProfileApiFactory,
};

export type IdentityService = {
  [K in keyof typeof apiFactories]: ReturnType<(typeof apiFactories)[K]>;
};

export const initializeIdentityService = (params: InitializeService) => {
  const baseConfig = {
    basePath: params.service_url,
  };
  const apiQueryConfig = new Configuration(baseConfig);
  const { accessToken } = params;
  const config = accessToken
    ? new Configuration({ ...baseConfig, accessToken })
    : apiQueryConfig;
  return Object.fromEntries(
    Object.entries(apiFactories).map(([key, factory]) => [
      key,
      factory(config),
    ]),
  ) as IdentityService;
};
